<template>
	<div id="app">
		<template v-if="hasHeader">
			<Header3></Header3>
		</template>
		<section class="section">
			<router-view />
		</section>
	</div>
</template>
<script>
import Header3 from '@/components/header3.vue';

export default {
	name: '',
	components: {
		Header3
	},
	data() {
		return {
			hasHeader: true,
		};
	},
	mounted() {
		this.syncHeaderStatus(this.$route);
	},
	watch: {
		'$route'(to) {
			this.syncHeaderStatus(to);
		}
	},
	methods: {
		syncHeaderStatus(route) {
			this.hasHeader = !(route.path == '/mapFull' || route.path == '/mapFullImg');
		}
	}
};
</script>
<style>
	.section{
		height: calc( 100vh - 74px );
	}
	
</style>
